var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "character-detail" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "head" }, [
        _c("div", { staticClass: "image-container" }, [
          _c(
            "div",
            { staticClass: "image" },
            [
              _c("image-view", {
                attrs: {
                  src: _vm.getCharacterKey,
                  placeholder: "/img/placeholders/character.png",
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "summary" }, [
          _c("div", { staticClass: "summary-header" }, [
            _c(
              "div",
              { staticClass: "main" },
              [
                _c("attribute", {
                  attrs: {
                    name: _vm.$t("characterPage.characterDetail.role"),
                    value: _vm.detail.role,
                  },
                }),
                _c("attribute", {
                  attrs: {
                    name: _vm.$t("characterPage.characterDetail.name"),
                    value: _vm.character.name,
                  },
                }),
                _c("attribute", {
                  attrs: {
                    name: _vm.$t("characterPage.characterDetail.alias"),
                    value: _vm.detail.alias,
                  },
                }),
              ],
              1
            ),
            _vm.editorMenuVisible
              ? _c(
                  "div",
                  { staticClass: "history-icon-container" },
                  [
                    _c("history-icon", {
                      staticClass: "history-icon",
                      attrs: { fillColor: "#a0a0a0" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("showHistoryDialog")
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "main-2" }, [
            _c(
              "div",
              [
                _c("attribute", {
                  attrs: {
                    name: _vm.$t("characterPage.characterDetail.age"),
                    value: _vm.detail.age,
                  },
                }),
                _c("attribute", {
                  attrs: {
                    name: _vm.$t("characterPage.characterDetail.gender"),
                    value: _vm.detail.gender,
                  },
                }),
                _c("attribute", {
                  attrs: {
                    name: _vm.$t("characterPage.characterDetail.birthdate"),
                    value: _vm.detail.birthdate,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              [
                _c("attribute", {
                  attrs: {
                    name: _vm.$t("characterPage.characterDetail.bloodType"),
                    value: _vm.detail.bloodType,
                  },
                }),
                _c("attribute", {
                  attrs: {
                    name: _vm.$t("characterPage.characterDetail.height"),
                    value: _vm.detail.height,
                  },
                }),
                _c("attribute", {
                  attrs: {
                    name: _vm.$t("characterPage.characterDetail.weight"),
                    value: _vm.detail.weight,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "main-3" }, [
        _c(
          "div",
          [
            _c("attribute", {
              attrs: {
                name: _vm.$t("characterPage.characterDetail.age"),
                value: _vm.detail.age,
              },
            }),
            _c("attribute", {
              attrs: {
                name: _vm.$t("characterPage.characterDetail.gender"),
                value: _vm.detail.gender,
              },
            }),
            _c("attribute", {
              attrs: {
                name: _vm.$t("characterPage.characterDetail.birthdate"),
                value: _vm.detail.birthdate,
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          [
            _c("attribute", {
              attrs: {
                name: _vm.$t("characterPage.characterDetail.bloodType"),
                value: _vm.detail.bloodType,
              },
            }),
            _c("attribute", {
              attrs: {
                name: _vm.$t("characterPage.characterDetail.height"),
                value: _vm.detail.height,
              },
            }),
            _c("attribute", {
              attrs: {
                name: _vm.$t("characterPage.characterDetail.weight"),
                value: _vm.detail.weight,
              },
            }),
          ],
          1
        ),
      ]),
      _c("hr", { attrs: { width: "100%" } }),
      _c(
        "div",
        { staticClass: "main-4" },
        [
          _c("attribute", {
            attrs: {
              "hide-on-empty": "",
              "is-detail": "",
              name: _vm.$t("characterPage.characterDetail.personality"),
              value: _vm.detail.personality,
            },
          }),
          _c("attribute", {
            attrs: {
              "hide-on-empty": "",
              "is-detail": "",
              name: _vm.$t("characterPage.characterDetail.individuality"),
              value: _vm.detail.individuality,
            },
          }),
          _c("attribute", {
            attrs: {
              "hide-on-empty": "",
              "is-detail": "",
              name: _vm.$t("characterPage.characterDetail.skill"),
              value: _vm.detail.skill,
            },
          }),
          _c("attribute", {
            attrs: {
              "hide-on-empty": "",
              "is-detail": "",
              name: _vm.$t("characterPage.characterDetail.ability"),
              value: _vm.detail.ability,
            },
          }),
          _c("attribute", {
            attrs: {
              "hide-on-empty": "",
              "is-detail": "",
              name: _vm.$t("characterPage.characterDetail.looks"),
              value: _vm.detail.looks,
            },
          }),
          _c("attribute", {
            attrs: {
              "hide-on-empty": "",
              "is-detail": "",
              name: _vm.$t("characterPage.characterDetail.personalHistory"),
              value: _vm.detail.personalHistory,
            },
          }),
          _c("attribute", {
            attrs: {
              "hide-on-empty": "",
              "is-detail": "",
              name: _vm.$t("characterPage.characterDetail.background"),
              value: _vm.detail.background,
            },
          }),
          _c("attribute", {
            attrs: {
              "hide-on-empty": "",
              "is-detail": "",
              name: _vm.$t("characterPage.characterDetail.other"),
              value: _vm.detail.other,
            },
          }),
          _vm._l(_vm.additionalColumn, function (item) {
            return [
              _c("attribute", {
                key: item.name,
                attrs: {
                  "is-detail": "",
                  name: item.label,
                  value: item.content,
                },
              }),
            ]
          }),
        ],
        2
      ),
      _vm.editorMenuVisible
        ? _c(
            "div",
            [
              _c(
                "button-round",
                {
                  staticClass: "character-detail-edit-button",
                  attrs: {
                    to: {
                      name: "characterEdit",
                      params: {
                        novelId: _vm.novelId,
                        characterId: _vm.character.characterId,
                        edit: "edit",
                      },
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.edit")) + " ")]
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }